/*
 * Copyright (c) 2019, Ahmed Allem <ahmed.allem@gmail.com>
 *
 * License: MIT
 */

import React, {useState } from "react";

import { insertDataBlock, MegadraftIcons } from "megadraft";

import PickerImage from "../../Modals/PickerImage";

const Button = (props) => {

  const {className, onChange, PLUGIN_NAME, editorState} = props;

  const [isImage, setImage] = useState(false);

  const onSave = (selected_image) => {

    setImage(false);

    const data = {
      src: selected_image, type: "click_imagepicker", display: "medium"
    }

    console.log("SAVE => ",data);
    onChange(insertDataBlock(editorState, data));
  }

  return (
    <div>
      <button className={className} type="button" onClick={()=>setImage(true)} title={PLUGIN_NAME}>
        <MegadraftIcons.ImageIcon className="sidemenu__button__icon" />
      </button>
      {isImage && (
        <PickerImage {...props}
          onClose={() => setImage(false)}
          onSelectImage={onSave}
          TYPE={'blog'}

        />
      )}
      {/* <BlockManager isEditing={isEditing} onClose={setEditing(false)} onSave={onSave} data={{}} /> */}
    </div>
  );

}

export default Button;

// export default class ButtonX extends Component {
//   constructor(props) {
//     super(props);
//     this.onClick = this.onClick.bind(this);
//     this.onSave = this.onSave.bind(this);
//     this.onModalClose = this.onModalClose.bind(this);

//     this.state = {isEditing: false};
//   }

//   onClick(e) {
//     this.setState({isEditing: true});

//     console.log("CHECK IF ")

//   }

//   onModalClose() {
//     if (this.state.isEditing) {
//       this.setState({isEditing: false});

//     }
//   }

//   onSave(selected_image) {
    
//     this.setState({isEditing: false});
//     const data = {
//       src: selected_image, type: "click_imagepicker", display: "medium"
//     }
//     console.log("SAVE => ",data);
//     this.props.onChange(insertDataBlock(this.props.editorState, data));
//   }

//   render() {
//     return (
//       <div>
//         <button className={this.props.className} type="button" onClick={this.onClick} title={this.props.PLUGIN_NAME}>
//           <MegadraftIcons.ImageIcon className="sidemenu__button__icon" />
//         </button>
//         <BlockManager isOpen={this.state.isEditing} onCloseRequest={this.onModalClose} onSaveRequest={this.onSave} data={{}} />
//       </div>
//     );
//   }
// }
